function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSvgStylingDefs = function SvgSvgStylingDefs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      height: 0,
      width: 0
    }
  }, props));
};
export default SvgSvgStylingDefs;